module.exports = __webpack_public_path__ + "static/img/3c815fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dy/success.png
// module id = 637
// module chunks = 2